import { AxiosInstance } from 'axios'
import { ApiResult } from '../server.api'

// Api interface
export default class AssocApeCcnApi {
  instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(target: assocApeCcn): Promise<ApiResult<assocApeCcn>> {
    return this.instance.post('/AssocApeCcn', target)
  }

  async delete(target: assocApeCcn): Promise<ApiResult<assocApeCcn>> {
    return this.instance.delete('/AssocApeCcn', { data: target })
  }
}

// Types
type assocApeCcn = {
  apeId: number
  ccnId: number
  pourcentage: number
  nombreSalarie: number
}

export { assocApeCcn }
